import React, { FC } from 'react'
import GoalList from './GoalList'
import GoalDetail from './GoalDetail'
import { GoalBundle } from '../../../../types/FHIRTypes/Bundle'

type GoalsProps = {
  goalData: GoalBundle;
  goalDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const Goals: FC<GoalsProps> = ({ goalData, goalDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
  return (
    <div>
      {
        goalDetailId && page === 'Goal' ? (
          <GoalDetail
            goalDetailId={goalDetailId}
          />
        ) :
          <GoalList
            goalData={goalData}
            isFetching={isFetching}
            handleChangePage={handleChangePage}
            totalPages={totalPages}
            currentPage={currentPage}
          />
      }
    </div>
  )
}

export default Goals